import React from 'react';

interface QueueDisplayProps {
  queue: any[];
  className?: string;
}

const QueueDisplay: React.FC<QueueDisplayProps> = ({ queue, className = '' }) => {
  if (queue.length === 0) return null;

  // Show the next up to 3 songs in the queue. Index 0 is the immediate next song.
  const nextSongs = queue.slice(0, 3);
  
  return (
    <div className={`fixed top-6 left-6 bg-black/70 text-white rounded-lg p-4 z-40 max-w-sm ${className}`}>
      <h3 className="text-lg font-semibold mb-3 m-0">Up Next:</h3>
      <ul className="list-none p-0 m-0">
        {nextSongs.map((song, idx) => (
          <li key={song.id} className="mb-2 text-sm">
            <span className="font-medium text-qr-secondary">{idx + 1}.</span> {song.title}
            <span className="text-gray-300 ml-2">({song.singerName || song.requestedBy || 'Unknown'})</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QueueDisplay;